export interface SelectionChange {
    selected: Set<string>;
    anchorKey: string | null;
}

export function toggleSelection(
    orderedSelectableKeys: string[],
    selected: Set<string>,
    key: string,
    shiftKey: boolean,
    anchorKey: string | null,
): SelectionChange {
    if (!orderedSelectableKeys.includes(key)) return {selected, anchorKey};

    const next = new Set(selected);
    const willSelect = !selected.has(key);

    if (shiftKey && anchorKey !== null) {
        const anchorIndex = orderedSelectableKeys.indexOf(anchorKey);
        const targetIndex = orderedSelectableKeys.indexOf(key);
        if (anchorIndex !== -1 && targetIndex !== -1) {
            const [from, to] = anchorIndex < targetIndex
                ? [anchorIndex, targetIndex]
                : [targetIndex, anchorIndex];
            for (const rangeKey of orderedSelectableKeys.slice(from, to + 1)) {
                if (willSelect) next.add(rangeKey);
                else next.delete(rangeKey);
            }
            return {selected: next, anchorKey: key};
        }
    }

    if (willSelect) next.add(key);
    else next.delete(key);
    return {selected: next, anchorKey: key};
}

export function toggleSelectAll(
    orderedSelectableKeys: string[],
    selected: Set<string>,
): Set<string> {
    const allSelected = orderedSelectableKeys.length > 0
        && orderedSelectableKeys.every((key) => selected.has(key));
    if (allSelected) return new Set();
    return new Set(orderedSelectableKeys);
}

export function restrictSelection(selected: Set<string>, visibleSelectableKeys: string[]): Set<string> {
    const allowed = new Set(visibleSelectableKeys);
    const next = new Set<string>();
    for (const key of selected) {
        if (allowed.has(key)) next.add(key);
    }
    return next;
}
